import { Helmet } from "react-helmet";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import Networking from "../../components/solutions/networking/Networking";
import NetworkingFaqsBody from "../../components/faqs/NetworkingFaqsBody";
import RelatedNetworking from "../../components/solutions/networking/RelatedNetworking";

export default function Networks() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/networking"
        />
        <meta
          name="description"
          content="Design, setup, and maintenance of LAN/WAN networks, Wi-Fi coverage planning, structured cabling, and IT infrastructure upgrades."
        />
        
        <meta
          property="og:description"
          content="Design, setup, and maintenance of LAN/WAN networks, Wi-Fi coverage planning, structured cabling, and IT infrastructure upgrades."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Networking & Infrastructure Setup | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Networking & Infrastructure Setup | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Networking & Infrastructure Setup | Uganda"
        />
        <meta
          name="twitter:description"
          content="Design, setup, and maintenance of LAN/WAN networks, Wi-Fi coverage planning, structured cabling, and IT infrastructure upgrades."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | Solutions | Networking & Infrastructure Setup | Uganda
        </title>
      </Helmet>
      <SolutionItemHero
        title="Networking & Infrastructure Setup"
        subtitle="Get your networking systems setup right from Wifi, LAN, and structured cabling to network security for a stable, fast and secure network that supports your daily operations, communications and digital systems without interruption."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <Networking />
      <SolutionCTA ctaTitle="Ready To Have Your LAN/WAN Networks Setup Right?" />
      <NetworkingFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your LAN/WAN Networks Setup Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your LAN/WAN Networks Setup Right?" />
      <RelatedNetworking />
    </>
  );
}
